<div class="mt-5 grid grid-cols-1 gap-4 rounded-lg border border-white-dark/20 bg-slate-100 p-3 sm:grid-cols-3">
  <div class="col-span-1 flex items-center justify-between text-xl font-bold sm:col-span-3">
    {{ "download_confirmation_einvoice" | translate }}
  </div>

  <div class="col-span-3 grid grid-cols-1 md:grid-cols-3">
    <div class="col-span-1 flex justify-between sm:pl-3">
      <button class="btn btn-primary w-auto" (click)="openEInvoiceModal()">{{ "e-invoice.enable_eInvoice" | translate }}</button>
    </div>
  </div>
</div>

<ng-template #eInvoiceEnableTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "e-invoice.enable_eInvoice" | translate }}</div>
    <form (submit)="submitForm()" [formGroup]="form" class="grid grid-cols-1">
      <div [ngClass]="form.controls['eInvoiceApiKey'].touched ? (form.controls['eInvoiceApiKey'].errors ? 'has-error' : 'has-success') : ''" class="mt-3">
        <label for="fiscomApiKey">{{ "e-invoice.api_key" | translate }}</label>
        <input type="text" placeholder="{{ 'e-invoice.enter_api_key' | translate }}" class="form-input" id="eInvoiceApiKey" formControlName="eInvoiceApiKey" />
        <ng-container *ngIf="form.controls['eInvoiceApiKey'].touched && form.controls['eInvoiceApiKey'].errors">
          <p class="mt-1 text-danger">
            <small>{{ "e-invoice.please_provide_api_key" | translate }}</small>
          </p>
        </ng-container>
      </div>

      <button class="btn btn-primary mt-3" type="submit" [disabled]="loading">
        <ng-container *ngIf="loading; else alternateTranslation">
          <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
          {{ "loading" | translate }}
        </ng-container>
        <ng-template #alternateTranslation>
          {{ "save" | translate }}
        </ng-template>
      </button>
    </form>
  </div>
</ng-template>
